import { InstituteLogo } from "@/components/InstituteLogo";

interface HeaderProps {
  title: string;
  meta?: string;
  current: number;
  total: number;
  onFullscreen: () => void;
  isChildTheme: boolean;
  /** Admin panel “Preview” — show badge (no analytics on backend) */
  adminPreview?: boolean;
}

export function Header({ title, meta, current, total, onFullscreen, adminPreview }: HeaderProps) {
  return (
    <header
      className="flex items-center justify-between gap-3 px-3 sm:px-4 py-2 shrink-0 text-white shadow-md"
      style={{
        fontFamily: "var(--lp-font-heading)",
        background: `linear-gradient(90deg, var(--lp-header-from), var(--lp-header-to))`,
      }}
    >
      <div className="shrink-0 rounded-lg bg-white/15 p-1 ring-1 ring-white/20">
        <InstituteLogo height={36} className="drop-shadow-sm" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <h1 className="font-bold text-base sm:text-lg truncate" style={{ fontFamily: "var(--lp-font-heading)" }}>
            {title}
          </h1>
          {adminPreview && (
            <span
              className="shrink-0 rounded-md bg-amber-400/95 px-2 py-0.5 text-[10px] sm:text-[11px] font-bold uppercase tracking-wide text-amber-950 shadow-sm"
              title="You’re previewing as admin — progress and exit-quiz scores aren’t saved"
            >
              Admin preview
            </span>
          )}
        </div>
        {meta && <p className="text-[11px] sm:text-xs opacity-90 truncate">{meta}</p>}
      </div>
      <span className="shrink-0 tabular-nums text-sm opacity-95">
        {current} / {total}
      </span>
      <button
        type="button"
        onClick={onFullscreen}
        className="shrink-0 p-1.5 rounded hover:bg-white/20 transition-colors"
        aria-label="Toggle fullscreen"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
        </svg>
      </button>
    </header>
  );
}
